<template>
  <div class="p-grid">
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="org">{{ _t("label_orgs") }}</label>
      <div class="p-col-4">
        <MultiSelectableBreadcrumb
          :singleSelection="false"
          @change="setOrgId"
        ></MultiSelectableBreadcrumb>
      </div>
    </div>
    <!--  <div class="p-field p-grid">-->
    <!--    <label for="year" class="p-col-fixed" style="width:100px">Year*</label>-->
    <!--    <div class="p-col">-->
    <!--      <Calendar v-model="year" view="year" id="year" dateFormat="yy" placeholder="Select year" autocomplete="off" />-->
    <!--    </div>-->
    <!--  </div>-->
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2" for="month">{{ _t("label_month") }}*</label>
      <div class="p-col-4">
        <Calendar
          id="month"
          v-model="month"
          :placeholder="_t('select_month')"
          autocomplete="off"
          dateFormat="mm/yy"
          view="month"
        />
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2" for="title">{{ _t("specify_title") }}</label>
      <div class="p-col-4">
        <InputText
          id="title"
          v-model="title"
          :placeholder="_t('optional_title')"
          autocomplete="off"
        />
      </div>
    </div>
  </div>
  <Button
    :loading="loading"
    class="p-button-success"
    label="Download"
    @click="download"
  />
  <Toast />
</template>

<script>
import MultiSelectableBreadcrumb from "@/components/ixarma/MultiSelectableBreadcrumb";
import { getMonthlyReport } from "../../api/reports";
import moment from "moment";
import { formatApiError } from "@/utils/apiError";
import { getOrganizationSnapshot } from "@/state/organizationContext";

function getSelectedReportOrgIds() {
  const {multiOrgIds, orgId} = getOrganizationSnapshot()
  return multiOrgIds.length ? multiOrgIds : [{id: orgId ?? 1}]
}

export default {
  name: "report-monthly",
  components: {
    MultiSelectableBreadcrumb,
  },
  data: () => ({
    orgIds: getSelectedReportOrgIds(),
    year: null,
    month: null,
    title: "",
    loading: false,
  }),
  computed: {
    monthNames() {
      return [
        this._t("JANUARY"),
        this._t("FEBRUARY"),
        this._t("MARCH"),
        this._t("APRIL"),
        this._t("MAY"),
        this._t("JUNE"),
        this._t("JULY"),
        this._t("AUGUST"),
        this._t("SEPTEMBER"),
        this._t("OCTOBER"),
        this._t("NOVEMBER"),
        this._t("DECEMBER"),
      ]
    },
  },
  methods: {
    setOrgId: function (id) {
      this.orgIds = id;
    },
    download: function () {
      let isValid = true;
      let orgs = this.orgIds.length ? this.orgIds : getSelectedReportOrgIds();
      if (!orgs.length) {
        isValid = false;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Organizations is required",
          life: 3000,
        });
      }
      // if (!this.year) {
      //   isValid = false;
      //   this.$toast.add({severity:'error', summary: 'Error', detail:'Field \'Year\' can\'t be empty', life: 3000});
      // }
      if (!this.month) {
        isValid = false;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Field 'Month' can't be empty",
          life: 3000,
        });
      }
      if (isValid) {
        this.loading = true;
        return getMonthlyReport(
          orgs,
          moment(this.month).year(),
          moment(this.month).format("MMMM").toUpperCase(),
          this.title
        )
          .then(
            (res) => {
              if (res.status === 200) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                const blob = new Blob([res.data], { type: "xlsx" });
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                let headerLine = res.headers["content-disposition"];
                a.download = `${Date.now()}.xls`;
                if (headerLine) {
                  a.download = headerLine.split("=").pop().replace('"', "");
                }
                a.click();
                window.URL.revokeObjectURL(url);
                this.loading = false;
              }
            },
            (error) => {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: formatApiError(error, "Something went wrong", ": "),
                life: 3000,
              });
            }
          )
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
